import sortPieveActivityEvents from '@/lib/activityEvents/sortPieveActivityEvents.js';
import buildThreadContentItems from '@/lib/threads/buildThreadContentItems.js';
import mergeHydratedActivityEvents from '@/lib/activityEvents/mergeHydratedActivityEvents.js';
import { isRunStateInProgress } from '@/lib/pieveRunState.js';
import getThreadContentItemByThreadId from '@/lib/threads/getThreadContentItemByThreadId.js';
import shouldPreserveExistingRunStateDuringHydration from '@/lib/threads/shouldPreserveExistingRunStateDuringHydration.js';
import buildThreadContentShell from '@/redux/reducers/pieveReducer/buildThreadContentShell.js';

const buildThreadContentMap = ({ threads, eventsByThreadId, existingThreadContent = {} }) => {
  const next = {};

  for (const thread of threads || []) {
    const existingContent = getThreadContentItemByThreadId(existingThreadContent, thread.id) || {};
    const existingActivity = Array.isArray(existingContent?.activity) ? existingContent.activity : [];
    const incomingActivity = sortPieveActivityEvents(eventsByThreadId?.[thread.id] || []);
    const hasIncomingEventsForThread = Object.prototype.hasOwnProperty.call(eventsByThreadId || {}, thread.id);
    const existingRunState = existingContent?.runState || null;
    const incomingRunState = thread.runState || { state: 'idle', runId: null };
    const runState = shouldPreserveExistingRunStateDuringHydration({
      existingRunState,
      incomingRunState
    })
      ? existingRunState
      : incomingRunState;
    const shouldMergeHydratedActivity = isRunStateInProgress(existingRunState);
    const shouldPreserveExistingActivity = !hasIncomingEventsForThread && existingActivity.length > 0;
    const activity = shouldPreserveExistingActivity
      ? existingActivity
      : sortPieveActivityEvents(
          mergeHydratedActivityEvents({
            existingEvents: existingActivity,
            incomingEvents: incomingActivity,
            preserveProvisionalEvents: shouldMergeHydratedActivity
          })
        );
    next[thread.id] = buildThreadContentShell({
      thread,
      threadId: thread.id,
      existingContent,
      activity,
      runState,
      // Threads listed without their events still get a shell with an empty activity; only the ones
      // whose events came with this hydration are marked as fetched.
      eventsHydrated: hasIncomingEventsForThread
    });
  }

  return buildThreadContentItems(next);
};

export default buildThreadContentMap;
